export default [
  'registerReferences',
  'unregisterReferences',
  'registerSelectSegmentsCallback',
  'unregisterSelectSegmentsCallback',
  'registerOnPlayInfoUpdatedCallback',
  'unregisterOnPlayInfoUpdatedCallback',

  'seek',

  'setMarker',
  'clearMarker',

  'setLoopFullDuration',
  'setLoopByMarker',

  'setSegment',
  'setNewSegment',
  'generateEmptySegment',
  'generateAndAttachEmptyNote',
  'createSegment',
  'deleteSegments',
  'divideSegment',
  'copySegmentsFromCopySource',

  'removeTimelineData',
  'renameTimelineData',
  'lockTimeline',
  'unlockTimeline',
  'hideTimelineData',
  'unhideTimelineData',
  'duplicateTimelineData',
  'generateNewTimelineData',
  'generateNewHiddenTimelineData',
  'getTimelineDataImmutableReason',

  'invokeActionOnSelectedTimelineSegments',
  'selectTimelineSegments',
  'selectTimelineSegmentAndSeek',
  'clearSelectedTimelineSegments',

  'atomicChanges',
  'registerChange',
  'registerFooterMessage',
  'undoChange',
  'redoChange',
]